


















import { Component, Prop, Vue } from "vue-property-decorator";

import { TemplateColor } from "@/data/templateColor/templateColor"

import * as def from "@/definitions";

import { ResourceHelper } from "@/helper/resourceHelper";

@Component({
  components: {
    }
})
export default class TemplateColorView extends Vue 
{
    @Prop() templateColor! : TemplateColor;
    @Prop() selectedTemplateColor!: TemplateColor;

    selectTemplateColor(){
        this.$emit("selectTemplateColor" , this.templateColor)
    }

    get isSelected(){
        return this.templateColor == this.selectedTemplateColor
    }

    private get userConfigBorderColor(){
        var style = {
            border : "solid 2px " + this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
